// Generated by Copilot- Start
import { SvodPromoMap } from "lib/helper/channel-interactive-tool-v2";

/**
 * Extracts SVOD channel names and duration from svodPromoMap
 * @param channelLabel - The label/name of the channel
 * @param svodPromoMap - Map of channel labels to package IDs to promo text
 * @returns Formatted string like "3 months, Max, Starz, Paramount+ with SHOWTIME and Cinemax"
 */
export const buildSvodFooterText = (
  channelLabel: string,
  svodPromoMap: SvodPromoMap = {}
): string => {
  if (!svodPromoMap || !svodPromoMap[channelLabel]) {
    return '';
  }

  const svodChannelList: string[] = [];
  let svodDuration = '';
  const seenChannels = new Set<string>();
  const channelPromos = svodPromoMap[channelLabel];

  // Iterate through all packages that have SVOD promos for this channel
  Object.entries(channelPromos).forEach(([_packageId, promoText]) => {
    // promoText format: "Get Max, Starz, Paramount+ with SHOWTIME and Cinemax, 3 months included with new service*"
    // Extract the SVOD names and duration
    const match = promoText.match(/Get\s+(.+),\s+(\d+)\s+month/i);
    if (match) {
      const channelNames = match[1]; // e.g., "Max, Starz, Paramount+ with SHOWTIME and Cinemax"
      const duration = match[2]; // e.g., "3"

      // Store duration (should be same across all packages)
      if (!svodDuration) {
        svodDuration = `${duration} ${parseInt(duration) > 1 ? 'months' : 'month'}`;
      }

      // Add channel names that haven't been seen yet
      const names = channelNames.split(',').map(n => n.trim());
      names.forEach(name => {
        if (!seenChannels.has(name)) {
          svodChannelList.push(name);
          seenChannels.add(name);
        }
      });
    }
  });

  // Format the final string: "3 months, Max, Starz, Cinemax"
  return svodDuration && svodChannelList.length > 0 ?
    `${svodDuration}, ${svodChannelList.join(', ')}` :
    '';
};
// Generated by Copilot- End
